export default __webpack_public_path__ + "static/media/GearNavyBlue.f74c77e8.jpg";